import { Minus } from "lucide-react";
import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
const Conference = () => {
  const images = [
  { id: 1, src: '/images/corpo/conference-all.jpg', title: 'CONFERENCES' },
  { id: 2, src: '/images/home/BANQUETS.jpg', title: 'Card Two' },
  { id: 3, src: '/images/home/timeless.jpg', title: 'Card Three' },
];
  return (


     
    <>
    <Helmet>
        <title>Conferences and Events | V Hotel The Grand Shoba</title> {/* SEO Title */}
        <meta name="description" content="Host your next corporate event, conference, or meeting at V Hotel The Grand Shoba, Mahipalpur, Delhi. Discover premium corporate halls and banquet spaces, conveniently located near IGI Airport." /> {/* SEO Meta Description */}
        <link rel="canonical" href="https://www.yourwebsite.com/conferences" /> {/* Canonical Link */}
      </Helmet>
    <div className="text-center my-2 px-3" id="events">
      <h3 className="fw-bold mb-3">
        <span className=" corpo-conference py-2">
        <Minus/>  CONFERENCES AND EVENTS<Minus/>
        </span>
      </h3>
      
      <p className=" corpo-conference-para mx-auto" style={{ maxWidth: "700px" }}>
      Host your next conference in Mahipalpur, Delhi with effortless style. Our curated collection of corporate halls and banquet spaces are ideal for corporate events, team meetings, business conferences, and private corporate lunches or dinners. Located near  IGI Airport, V Hotel The Grand Shoba is your premium choice for Delhi corporate gatherings. Discover elevated event experiences in the heart of Mahipalpur—where business meets excellence.
      </p>
    <Link to="/corporate-query" >
      <button className=" conference-btn   my-3 px-4">
        ENQUIRE NOW
      </button>
      </Link>
      {/* <div className="mt-4 conference-img-div">
      <img 
          src="/images/corpo/conference-all.jpg"
          alt="V Hotel The Grnad Shoba conference Hall  " loading="lazy" title="V Hotel The Grnad Shoba Conference-Event-Hall"
          className=" rounded shadow"
        />

     
      </div> */}
    </div>


  {/* first animation*/}
    {/* <div className="container ">
        <div className="row mt-5">
          <div className="col-md-4 mb-3">
            <div class="conference-image-parent">
              <div class="conference-image-child">
                <div class="front">
                  <p class="front-heading">CONFERENCES</p>
                  <p className="heartbeat-wrapper">
                    <span className="ring"></span>
                     <span className="heartbeat"> View</span>
                    </p>
                </div>
                <div class="back">
                  <img src="/images/corpo/conference-all.jpg" alt="conference-all v hotel the  grand shoba" />
                </div>
              </div>
            </div>

          </div>
           <div className="col-md-4 mb-3 ">
            <div class="conference-image-parent">
              <div class="conference-image-child">
                <div class="front">
                  <p class="front-heading">BANQUET HALL</p>
                   <p className="heartbeat-wrapper">
                    <span className="ring"></span>
                     <span className="heartbeat"> View</span>
                    </p>
                </div>
                <div class="back">
                  <img src="/images/home/BANQUETS.jpg" alt="BANQUETS v hotel the grand shoba" />
                </div>
              </div>
            </div>

          </div>
           <div className="col-md-4 mb-3 ">
            <div class="conference-image-parent">
              <div class="conference-image-child">
                <div class="front">
                  <p class="front-heading text-uppercase ">collaborate hall</p>
                   <p className="heartbeat-wrapper">
                    <span className="ring"></span>
                     <span className="heartbeat"> View</span>
                    </p>
                </div>
                <div class="back">
                  <img src="/images/home/timeless.jpg" alt="timeless V Hotel the grand shoba" />
                </div>
              </div>
            </div>

          </div>
        </div>
    </div> */}


 <Container className="my-5">
      <Row>
        {images.map((img) => (
          <Col key={img.id} xs={12} sm={6} md={4} className="mb-4">
            <div
              className="conference-card-parent card-container"
              style={{ backgroundImage: `url(${img.src})` }}
            >
              <div className="card-content">
                {/* <h5 className="text-center">{img.title}</h5> */}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>

    {/* second animation */}
    {/* <div className="container ">
        <div className="row mt-5">
          <div className="col-md-4 mt-2">
           <div class="conference-image2-parent">
      
        <div class="profile-pic">
             <img src="/images/corpo/conference-all.jpg" alt="" />
                   
       
        </div>
        <div class="bottom">
      
            <div class="conference-image2-child">
                <span class="name ">Conference </span>
                <span class="about-me text-light">Lorem ipsum dolor sit amet consectetur adipisicinFcls </span>
            </div>
          
        </div>
                </div>
           
           </div>
        </div>
    </div> */}


    </>
  );
};

export default Conference;
